module.exports = __webpack_public_path__ + "img/IBowman64_ua.b40888f5.webp";